<template>
    <!-- The Modal -->
    <b-modal
        id="email-preview-modal"
        :title="'Email Preview'"
        :hide-footer="true"
        v-model="modalOpen"
        no-fade
        size="lg"
        @change="onModalChange"
        @hide="onModalChange"
        @show="onModalChange">
        <div class="modal-content">
            <div class="email-content" v-html="emailHtml"></div>
        </div>
    </b-modal>
</template>

<script>
export default {
    props: {
        emailHtml: String,
        value: Boolean
    },
    data() {
        return {
            modalOpen: this.value,
        }
    },
    watch: {
        value() {
            this.modalOpen = !!this.value;
        },
    },
    methods: {
        onModalChange(){
            this.$emit('input', this.modalOpen);
        }
    }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// resources/js/components/EmailRecord/EmailPreviewModal.vue